document.addEventListener('DOMContentLoaded', function () {
  // Color swatch functionality on hover. Also updates the product link href to
  // include the variant ID.
  const productBlocks = document.querySelectorAll('.product-block-colorway');

  productBlocks.forEach(productBlock => {
    const optionItems = productBlock.querySelectorAll('.product-block-options__item');
    const imageEl = productBlock.querySelector('.product-block__image_colorway img');
    const linkEl = productBlock.querySelector('a.product-link');

    if (!imageEl || !linkEl) return;

    const originalSrcset = imageEl.srcset;
    const originalHref = linkEl.getAttribute('href');

    const srcsetWidths = Array.from(originalSrcset.matchAll(/(\d+)(?=w)/g)).map(match => match[0]);

    function buildSrcset(baseUrl) {
      return srcsetWidths
        .map(w => {
          const separator = baseUrl.includes('?') ? '&' : '?';
          return `${baseUrl}${separator}width=${w} ${w}w`;
        })
        .join(', ');
    }

    optionItems.forEach(item => {
      function updateImageAndUrl() {
        const baseUrl = item.getAttribute('data-full-image');
        const variantId = item.getAttribute('data-variant-id');

        if (baseUrl) {
          const separator = baseUrl.includes('?') ? '&' : '?';
          const maxWidth = Math.max(...srcsetWidths.map(Number));
          imageEl.src = `${baseUrl}${separator}width=${maxWidth}`;
          imageEl.srcset = buildSrcset(baseUrl);
        }

        if (variantId && originalHref) {
          const url = new URL(originalHref, window.location.origin);
          url.searchParams.set('variant', variantId);
          linkEl.setAttribute('href', url.toString().replace(window.location.origin, ''));
        }
      }

      item.addEventListener('mouseenter', updateImageAndUrl);
      item.addEventListener('click', updateImageAndUrl);
    });
  });
});
